import { render, staticRenderFns } from "./Imprimir.vue?vue&type=template&id=0d8fb952&scoped=true&"
import script from "./Imprimir.vue?vue&type=script&lang=js&"
export * from "./Imprimir.vue?vue&type=script&lang=js&"
import style0 from "./Imprimir.vue?vue&type=style&index=0&id=0d8fb952&button-container=true&scoped=true&lang=css&"
import style1 from "./Imprimir.vue?vue&type=style&index=1&id=0d8fb952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8fb952",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VBtn,VCard,VCol,VContainer,VForm,VRadio,VRadioGroup,VRow,VSelect,VTextField})
